import logo from './logo.png';
import hero01 from './hero01.jpg';
export const assets = {logo, hero01}
export const products =[{
    _id: "aaaaa",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 150, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716634345448,
    bestseller: true
},
{
    _id: "akiab",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Men", 
    subCategory: "Bottomwear",
    sizes: ["s", "м", "L"],
    date: 1716674345447,
    bestseller: true
},{
    _id: "aerab",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 90, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716684545447,
    bestseller: true
},{
    _id: "aajub",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 85, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1714534345447,
    bestseller: true
},{
    _id: "ayaab",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 80, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716789345447,
    bestseller: true
},{
    _id: "oaaab",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 171669845447,
    bestseller: true
},{
    _id: "aauab",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716633485447,
    bestseller: true
},{
    _id: "ajaab",
    name: "Men Round Neck Linen Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1717734395447,
    bestseller: true
},{
    _id: "aalab",
    name: "Men Round Neck Cotton Shirt",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716634755447,
    bestseller: true
},{
    _id: "aaacb",
    name: "Women Round Neck Linen Shirt",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1765634345447,
    bestseller: true
},{
    _id: "ajaab",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1896634345447,
    bestseller: true
},{
    _id: "aaadr",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716638945447,
    bestseller: true
},{
    _id: "aaafr",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716633445447,
    bestseller: true
},{
    _id: "aaahh",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 100, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м", "L"],
    date: 1716634345467,
    bestseller: true
},{
    _id: "aaaac",
    name: "Women Round Neck Cotton Top",
    description: "A lightweight, usually knitted, pullover shirt, close-fitti",
    price: 10000, 
    image: ['https://picsum.photos/200', 'https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200','https://picsum.photos/200'], 
    category: "Women", 
    subCategory: "Topwear",
    sizes: ["s", "м"],
    date: 1716634785447,
    bestseller: true
},]